/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-header-card',
  standalone: true,
  imports: [MatButton, MatCardModule],
  templateUrl: './header-card.component.html',
  styleUrl: './header-card.component.scss',
})
export class HeaderCardComponent {
  title = input<string>();
}
